import { useMemo } from 'react';

import { useAppForm } from '@/features/dashboard/components/AppForm/AppForm/context';
import type { AppFormValues } from '@/features/dashboard/components/AppForm/AppForm/context/types';
import { getFormAppDefinition } from '@/features/dashboard/components/apps';
import { Preview } from '@/features/dashboard/components/Preview';

const FormPreviewContent = ({
  values,
  enabled
}: {
  values: AppFormValues | null;
  enabled: boolean;
}) => {
  const template = useMemo(() => {
    if (!values?.type) return undefined;
    return getFormAppDefinition(values.type).toWidget(values);
  }, [values]);
  return (
    <Preview
      enabled={enabled}
      template={template}
    />
  );
};

export const FormPreview = () => {
  const { form, canPreview } = useAppForm();
  return (
    <form.Subscribe selector={s => ({ values: s.values })}>
      {({ values }) => (
        <FormPreviewContent
          enabled={canPreview && !!values?.symbols?.active.length}
          values={values}
        />
      )}
    </form.Subscribe>
  );
};
